<!-- eslint-disable -->
<template lang="pug">
		.settings(v-if='settings')
				template(v-if="settings.withTime && settings.showTime && parametersFrom === 'homework'")
						| {{ $i18n.t('trainer.trainer_gameFormSetting_displaySpeed') }}:
						| {{ settings.showTime }}
						| {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
						br
				template
						template(v-if='settings.selectedGroups.length')
								span
										| {{ $i18n.t('trainer.trainer_gameFormSetting_groups') }}:
										| {{ settings.selectedGroups.join(', ') }}
								br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfRows') }}:
								| {{ settings.amountOfRows }}
						br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfWordsToRemember') }}:
								| {{ settings.amountOfWords }}
						br
						template(v-if='settings.invertedWords')
								span
										| {{ $i18n.t('trainer.trainer_gameFormSetting_invertedWords') }}:
										| {{ $i18n.t('common.common_button_yes') }}
								br
				br
				slot
</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from "../../../utils/trainer/gamePreviewMixin";

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework'
            }
        }
    }
</script>
